import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac726954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicator relative-position" }
const _hoisted_2 = { class: "absolute-center indicator__text" }
const _hoisted_3 = { class: "text-weight-semi-bold" }
const _hoisted_4 = { class: "text-gray-primary" }
const _hoisted_5 = { class: "text-gray-primary" }

import dataTestIds from 'app/cypress/e2e/dataTestIds';
import AppIcon from 'src/assets/AppIcon.vue';
import { useUserStore } from 'src/store/userStore';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PointsIndicator',
  setup(__props) {

const router = useRouter();
const user = useUserStore();
const { t } = useI18n();

const popupProxy = ref(null);

function handleClick() {
  (popupProxy.value as unknown as { hide: () => void }).hide();
  void router.push({ name: t('home') });
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppIcon, {
      name: "paw",
      width: 40,
      height: 40
    }),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(user).points), 1),
    _createVNode(_component_q_popup_proxy, {
      ref_key: "popupProxy",
      ref: popupProxy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "indicator-card q-pa-none q-pa-md flex" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('searchCounter')), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('numberOfSearches')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('averageSearches')), 1),
            _createVNode(_component_q_btn, {
              "data-testid": _unref(dataTestIds).HEADER.POINTS_INDICATOR_HANDLER,
              flat: "",
              class: "search-btn bg-yellow-primary text-white",
              label: _ctx.$t('searchNow'),
              onClick: handleClick
            }, null, 8, ["data-testid", "label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}
}

})